/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeStudioCurrentModel } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-options-datalabels',
  templateUrl: './theme-options-datalabels.component.html',
  styleUrls: ['./theme-options-datalabels.component.css']
})
export class ThemeOptionsDatalabelsComponent {

  @Input() themeOptions: ThemeOptionsClass;
  @Input() current: ThemeStudioCurrentModel;
  
  color = ItemColor('themes');

  editorIndex: number;
  editorIndexMax: number;

  constructor() {
    this.editorIndex = 0;
    this.editorIndexMax = 3;
  }

  receiveNext(isNext: boolean) {
    this.editorIndex = this.editorIndex + (isNext ? 1 : -1);
    if(this.editorIndex < 0) this.editorIndex = this.editorIndexMax;
    if(this.editorIndex > this.editorIndexMax) this.editorIndex = 0;
  } 

}
